import type { PrizeRule, PrizeRulable } from '@/types/prizes'
import { PrizeRulesKindsEnum } from '@/types/prizes'

/* `prizePartner` existe porque a regra de check-in nao tem alvo proprio: ela
   usa o Parceiro vinculado ao concurso, que desce em `prize.partner` e nao em
   `prize_rules[].prize_rulable`. */
export const getPrizeRuleMessage = (
  prizeRulable: PrizeRulable | null | undefined,
  kind: PrizeRulesKindsEnum | string,
  prizePartner?: { name?: string } | null
): string => {
  const ruleName = prizeRulable?.name || ''

  switch (kind) {
    case PrizeRulesKindsEnum.VOUCHER_BUYERS:
      return `Adquirir o voucher ${ruleName}`.trim()

    case PrizeRulesKindsEnum.GUILD_TOP:
      return `Ser o melhor da guilda ${ruleName}`.trim()

    case PrizeRulesKindsEnum.EVENT_TOP:
      return 'Estar entre os maiores pontuadores no ranking geral'

    case PrizeRulesKindsEnum.EVENT_PARTICIPANTS:
      return 'Participar do evento'

    case PrizeRulesKindsEnum.MISSION:
      return `Ter finalizado a missão ${ruleName}`.trim()

    case PrizeRulesKindsEnum.PARTNER_CHECKIN:
      return `Fazer check-in no parceiro ${prizePartner?.name || ''}`.trim()

    default:
      return 'Critérios não atendidos'
  }
}

export const getPrizeIneligibilityHint = (
  rules: PrizeRule[] | undefined,
  prizePartner?: { name?: string } | null
): string => {
  const first = rules?.[0]
  if (!first) return 'Critérios não atendidos'

  return getPrizeRuleMessage(first.prize_rulable, first.kind, prizePartner)
}

export const isPrizeOpenEnrollment = (rules: PrizeRule[] | undefined): boolean =>
  !!rules?.some(rule => rule.kind === PrizeRulesKindsEnum.EVENT_PARTICIPANTS)

export const getPrizeEligibleParticipantsLabel = (
  rules: PrizeRule[] | undefined
): string | null => {
  const ranked = rules?.find(
    rule =>
      rule.kind === PrizeRulesKindsEnum.GUILD_TOP ||
      rule.kind === PrizeRulesKindsEnum.EVENT_TOP
  )

  if (!ranked?.limit) return null

  const count = ranked.limit
  const verb = count === 1 ? 'participa' : 'participam'

  if (ranked.kind === PrizeRulesKindsEnum.GUILD_TOP) {
    return `Top ${count} da guilda ${verb}`
  }

  return `Top ${count} ${verb}`
}
